/** メディアメッセージを表す msg_type の値（画像/動画とも "FILE"） */
const FILE_MSG_TYPE = "FILE";

/**
 * 会話一覧のメディアマーク有無を判定する。
 * 最新メッセージ(msg_type) または直前メッセージ(one_before_msg_type) が
 * メディア("FILE") なら true。Utage 本家の挙動に準拠（「画像→テキスト」でも表示）。
 * 画像/動画の区別はサーバーが返さない（どちらも "FILE"）ため行わない。
 */
export const hasMediaMark = (
  msgType: string | null | undefined,
  oneBeforeMsgType: string | null | undefined,
): boolean => {
  return msgType === FILE_MSG_TYPE || oneBeforeMsgType === FILE_MSG_TYPE;
};
